module.exports = __webpack_public_path__ + "img/KRW.cca983e7.svg";